import React, { useCallback } from 'react';
import MaskedInput from 'react-text-mask';
import InputText from '../InputText';

const TextMaskCustom = ({ inputRef, mask, maxLength = 75, name, ...other }) => {
  const handleRef = useCallback(
    (ref) => {
      const element = ref ? ref.inputElement : null;
      if (typeof inputRef === 'function') {
        inputRef(element);
      } else if (inputRef != null) {
        // Use Object.assign to avoid direct prop mutation flagged by React compiler
        Object.assign(inputRef, { current: element });
      }
    },
    [inputRef]
  );

  return (
    <MaskedInput
      {...other}
      ref={handleRef}
      name={name}
      mask={mask}
      maxLength={maxLength}
      placeholderChar={'\u2000'}
      showMask
      guide={false}
    />
  );
};

const InputMask = ({
  name,
  label,
  placeholder = null,
  mask,
  maxLength = null,
  shrink = null,
  uppercase = null,
  boxShadow = null,
  labelGrey = false,
  labelMargin = false,
  ...props
}) => {
  return (
    <InputText
      name={name}
      label={label}
      placeholder={placeholder}
      maxLength={maxLength}
      shrink={shrink}
      labelGrey={labelGrey}
      labelMargin={labelMargin}
      uppercase={uppercase}
      boxShadow={boxShadow}
      // @ts-ignore
      inputComponent={TextMaskCustom}
      inputProps={{
        'data-testid': name,
        maxLength: maxLength || 75,
        mask,
        ...props,
      }}
    />
  );
};

export default InputMask;
